import { IoWarning } from "react-icons/io5";

export const WarningToast = ({ message }: { message: string }) => (
  <div className="c-warning-toast">
    <IoWarning className="c-warning-toast__icon" />
    <span className="c-warning-toast__message">{message}</span>
  </div>
);
